import React, { useMemo } from 'react';
import Dashboard from 'components/groups-dashboard/Dashboard';
import FiltersPanel from 'components/groups-dashboard/FiltersPanel';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { OverlaySpinner } from '@insurancemenu/imenu-components-lib';
import { GroupsDashboardPageStore, GroupsDashboardPageStoreContext } from 'store/pages/groups-dashboard/pageStore';
import { ContentStyled } from './styles';

const DashboardPage: React.FC = observer(() => {
  const {
    domainStoreV2: { imqSponsor, loading },
  } = useRootStore();
  const pageStore = useMemo(() => new GroupsDashboardPageStore(), []);

  return (
    <GroupsDashboardPageStoreContext.Provider value={pageStore}>
      <ContentStyled $isImqSponsor={imqSponsor}>
        {!imqSponsor && <FiltersPanel />}
        <Dashboard />
      </ContentStyled>
      <OverlaySpinner display={loading} />
    </GroupsDashboardPageStoreContext.Provider>
  );
});

export default DashboardPage;
